import React from "react";
import styled from "styled-components";

const Loading = () => {
  return (
    <StyledSpinner>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </StyledSpinner>
  );
};

export default Loading;

const StyledSpinner = styled.div`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 20px;

  div {
    position: absolute;
    top: calc(20px - 8px);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #333;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: 4px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  div:nth-child(2) {
    left: 6px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(3) {
    left: 20px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(4) {
    left: 32px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(12px, 0);
    }
  }
`;

// const StyledSpinner = styled.div`
//   display: inline-block;
//   position: relative;
//   width: 80px;
//   height: 80px;

//   div {
//     box-sizing: border-box;
//     display: block;
//     position: absolute;
//     width: 64px;
//     height: 64px;
//     margin: 8px;
//     border: 8px solid #fff;
//     border-radius: 50%;
//     animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
//     border-color: #000 transparent transparent transparent;
//   }

//   div:nth-child(1) {
//     animation-delay: -0.45s;
//   }

//   div:nth-child(2) {
//     animation-delay: -0.3s;
//   }

//   div:nth-child(3) {
//     animation-delay: -0.15s;
//   }

//   @keyframes lds-ring {
//     0% {
//       transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(360deg);
//     }
//   }
// `;
